import { mapGetters } from "vuex";
import LayoutLanding from "@/layouts/LayoutLanding/LayoutLanding.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";

export default {
    components: {
        LayoutLanding,
        Breadcrumb
    },
    data() {
        return {
            layout: LayoutLanding
        };
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    metaInfo() {
        return {
            title: this.$t(`thesaurus404MetaTitle`),
            meta: [
                {
                    name: "description",
                    content: this.$t(`thesaurus404MetaDescription`)
                },
                {
                    name: "robots",
                    content: "noindex"
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://thesaurus.yourdictionary.com/404/no-results`
                }
            ]
        };
    },
    created() {
        this.$emit("update:layout", LayoutLanding);
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined")
            this.$nextTick(() => {
                window.document.dispatchEvent(new CustomEvent("spa-render-complete"));
            });
    }
};



// WEBPACK FOOTER //
// ./src/pages/Synonyms/NoResults/SynonymNoResults.js